export default {"src":"/_next/static/media/crepe.c035eec2.svg","height":511,"width":512,"blurWidth":0,"blurHeight":0};